import React from 'react';
import styles from './Apollo.css';

const Apollo = ({ title, img, className, ...props }) => (
  <div className={`${styles.apollo} ${className}`} {...props}>
    <img className={styles.img} src={img} alt={title} />
  </div>
);

export default Apollo;



// WEBPACK FOOTER //
// ./src/components/Apollo/index.js